<template>
  <b-card>
    <user-edit-account
      v-if="loader === false"
      class="mt-2 pt-75"
      :user-data="userData"
      :form-data="formData"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { ref/* , onUnmounted */ } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import UserEditAccount from './UserEditAccount.vue'
import userStoreModule from '../userStoreModule'

export default {
  components: {
    BCard,
    UserEditAccount,
  },
  data() {
    return {
      loader: true,
      userData: ref(null),
      formData: ref(null),
    }
  },
  created() {
    // const userData = ref(null)
    const USER_APP_STORE_MODULE_NAME = 'app-user'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    store.dispatch('app-user/fetchUser', { id: router.currentRoute.params.id })
      .then(response => {
        this.userData = response.data.data
        this.formData = { ...response.data.data }
        this.loader = false
        // console.log('then', this.userData)
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.userData = undefined
        }
        if (error.response.status === 422) {
          console.log(error.response)
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              icon: 'CoffeeIcon',
              variant: 'danger',
              text: error.response.data.message,
            },
          })
          this.$router.push('/users/list')
        }
      })
  },
}
</script>

<style>

</style>
